import React from 'react';
import { appData } from 'Settings';

import styles from './StudentActivitySummaries.scss';
import StudentActivitySummary from 'Components/StudentActivitySummary';

const StudentActivitySummaries = ({ students }) => {
  return (
    <div className="StudentActivitySummaries">
      {appData.map(app => (
        <StudentActivitySummary
          key={`activity-${app.slug}`}
          app={app}
          students={students}
        />
      ))}
    </div>
  );
};

export default StudentActivitySummaries;
